import script from "./CourseView.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseView.vue?vue&type=script&setup=true&lang=js"

import "./CourseView.vue?vue&type=style&index=0&id=7a4ad9da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4ad9da"]])

export default __exports__